import React, { useEffect } from "react";

import { Layout,
  Breadcrumb
} from "antd";
import {
  ReadOutlined,
  QuestionCircleOutlined,
  UserOutlined,
  TeamOutlined,
  // ArrowDownOutlined,
  // ArrowUpOutlined
} from "@ant-design/icons";
import { Card, Col, Row, Statistic } from "antd";
import { useBackend } from "backend/useBackend";
import { useDispatch, useSelector } from "react-redux";
import { loadDashboard, selectCMS } from "features/cms/cmsSlice";
const { Content } = Layout;

const Dashboard = () => {
  const dispatch = useDispatch();
  const { dashboard } = useSelector(selectCMS);
  const { getList } = useBackend();

  useEffect(() => {
    getList("statistics/dashboard").then(({ stats }) => {
      console.log(stats);
      dispatch(loadDashboard(stats));
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Layout className="site-layout">
      <Content style={{ margin: "0 16px" }}>
        <Breadcrumb style={{ margin: "16px 0" }}>
          <Breadcrumb.Item>Dashboard</Breadcrumb.Item>
        </Breadcrumb>
        {/* <div className="bg-white" style={{ padding: 24, minHeight: "80vh" }}>
          Dashboard
        </div> */}
        <Row gutter={16}>
          <Col span={6}>
            <Card>
              <Statistic
                title="Quotes"
                value={dashboard.quotes}
                precision={0}
                valueStyle={{
                  color: "#3f8600",
                }}
                prefix={<ReadOutlined style={{ marginTop: '.5em', marginRight: ".5em", fontSize: '1.5em'}} />}
                // suffix="%"
              />
            </Card>
          </Col>
          <Col span={6}>
            <Card>
              <Statistic
                title="Authors"
                value={dashboard.authors}
                precision={0}
                // valueStyle={{
                //   color: "#cf1322",
                // }}
                prefix={<UserOutlined style={{ marginTop: '.5em', marginRight: ".5em", fontSize: '1.5em'}} />}
                // suffix="%"
              />
            </Card>
          </Col>
          <Col span={6}>
            <Card>
              <Statistic
                title="Topics"
                value={dashboard.topics}
                precision={0}
                // valueStyle={{
                //   color: "#cf1322",
                // }}
                prefix={
                  <QuestionCircleOutlined style={{ marginTop: '.5em', marginRight: ".5em", fontSize: '1.5em'}} />
                }
                // suffix="%"
              />
            </Card>
          </Col>
          <Col span={6}>
            <Card>
              <Statistic
                title="Users"
                value={dashboard.users}
                precision={0}
                // valueStyle={{
                //   color: "#cf1322",
                // }}
                prefix={<TeamOutlined style={{ marginTop: '.5em', marginRight: ".5em", fontSize: '1.5em'}} />}
                // suffix="%"
              />
            </Card>
          </Col>
        </Row>
      </Content>
      {/* <Footer style={{ textAlign: 'center' }}>Ant Design ©2018 Created by Ant UED</Footer> */}
    </Layout>
  );
};

export default Dashboard;
